







































































import { Component, Prop, Vue } from "vue-property-decorator";
import axios from "axios";
import {
  RedCapital,
  SelectedCountry,
  Configuration,
  TitleTemplatePublic
} from "@/configuration";
import GReCaptcha from "@/components/GReCaptcha.vue";
import API from "@/api";
import { EventBus } from "@/main";
import { isUserLogin } from "@/utils";

@Component({
  metaInfo: {
    title: "Contacto",
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang
    }
  },
  data() {
    return {
      valid: true,
      name: "",
      email: "",
      message: "",
      canPress: true,
      dialog: false,
      errorMessage: null,
      captcha: false,
      nameRules: [
        (v: any) => !!v || "Ingrese nombre",
        (v: any) =>
          v.length <= 255 || "Nombre no puede exceder los 255 caracteres."
      ],
      emailRules: [
        (v: any) => !!v || "Ingrese correo electrónico",
        (v: any) => /.+@.+/.test(v) || "La dirección debe ser válida"
      ],
      messageRules: [
        (v: any) => !!v || "Ingrese mensaje",
        (v: any) =>
          v.length >= 5 || "El mensaje debe tener al menos 5 caracteres."
      ]
    };
  },
  beforeMount() {
    isUserLogin(() => {
      this.$data.name = `${this.$store.state.user.nombre} ${this.$store.state.user.app_pat}`;
      this.$data.email = this.$store.state.user.email;
    });
  },
  methods: {
    async validate(response) {
      this.$data.canPress = false;
      // @ts-ignore
      if (this.$refs.form.validate()) {
        API.contact(this.$data.name, this.$data.email, '', this.$data.message)
          .then((data: any) => {
            this.$data.dialog = true;
            setTimeout(() => {
              this.$router.push({
                path: "/"
              });
            }, Configuration.Redirection.timeout);
          })
          .catch(res => {
            this.$data.canPress = true;
            this.$data.errorMessage = "Error";
            if (res.message.nombre != null) {
              EventBus.$emit("snack-error", res.message.nombre[0]);
            }
            if (res.message.mail != null) {
              EventBus.$emit("snack-error", res.message.mail[0]);
            }
            if (res.message.mensaje != null) {
              EventBus.$emit("snack-error", res.message.mensaje[0]);
            }
          });
      }
    },
    doRecaptcha() {
      // @ts-ignore
      this.$refs.recaptchaContact.execute();
    }
  },
  components: {
    GReCaptcha
  }
})
export default class Contact extends Vue {}
